import { gql } from 'graphql-request'

interface Facility {
  iconUrl: string | null
  id: string
  name: string
}

export interface AddressPoint {
  address1: string | null
  address2: string | null
  attentionName: string | null
  city: string | null
  companyName: string | null
  countryCode: string | null
  facility: Facility | null
  favorite: boolean
  firstName: string | null
  id: string
  lastName: string | null
  phoneNumber: string | null
  state: string | null
  zip: string | null
}

const facilityFragment = gql`
  fragment facility on Facility {
    iconUrl
    id
    name
  }
`

export const addressPointFragment = gql`
  fragment addressPoint on AddressPoint {
    address1
    address2
    attentionName
    city
    companyName
    countryCode
    facility {
      ...facility
    }
    favorite
    firstName
    id
    lastName
    phoneNumber
    state
    zip
  }
  ${facilityFragment}
`
